import React from 'react';

import CommonModal from 'jbc-front/components/CommonModal';
import styles from './EmployeePopUp.scss';
import { useTranslation, withTranslation } from 'react-i18next';

const PaySetupDescriptionModal = ({ isOpen, hideModal }) => {
  const { t } = useTranslation();
  const header = t('features.Dashbord.components.EmployeePopUp.employee_information_items_required_for_calculation');
  return (
    <CommonModal hideModal={hideModal} isOpen={isOpen} ariaHideApp={false}>
      <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <div>
          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.basic_information')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.last_name')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.first_name')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.birthday')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.title')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.personal_id')}</dd>
          </dl>

          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.business_information')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.first_day_at_work')}</dd>
          </dl>

          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.salary')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.salary_rules_group')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.basic_salary')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.unit_price')}</dd>
            {/* <dd>・ 標準報酬月額</dd> */}
          </dl>

          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.bank_information')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.employee_bank_information')}</dd>
          </dl>

          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.payment_setting')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.cash_or_bank_transfer')}</dd>
          </dl>

          <dl className={styles.information}>
            <dt>{t('features.Dashbord.components.EmployeePopUp.deduction_setting')}</dt>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.sosial_security_contribution_deduction')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.provident_fund_deduction')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.spouse_deduction')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.child_deduction')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.parents_deduction')}</dd>
            <dd>・ {t('features.Dashbord.components.EmployeePopUp.self_elderly_exemption')}</dd>
          </dl>

          {/* <dl className={styles.information}>
            <dt>通勤手当</dt>
            <dd>・ 支給単位</dd>
            <dd>・ 定期代</dd>
            <dd>・ 支給額</dd>
          </dl> */}

          {/* <dl className={styles.information}>
            <dt>扶養情報 ※被扶養者がいる場合のみ</dt>
            <dd>・ 姓（必須）</dd>
            <dd>・ 名（必須）</dd>
            <dd>・ 続柄（必須）</dd>
            <dd>・ 生年月日（必須）</dd>
          </dl> */}

          {/* <dl className={styles.information}>
            <dt>住民税</dt>
            <dd>・ 住民税金額</dd>
          </dl> */}

          {/* <dl className={styles.information}>
            <dt>社会保険</dt>
            <dd>・ 健康保険の加入状況と資格取得日</dd>
            <dd>・ 厚生年金保険の加入状況と資格取得日</dd>
            <dd>・ 雇用保険の加入状況と資格取得日</dd>
          </dl> */}
        </div>
      </CommonModal.Body>
    </CommonModal>
  );
};

class EmployeePopUp extends React.Component {
  state = {
    isModalOpen: false
  };

  openModal = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ ...this.state, isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ ...this.state, isModalOpen: false });
  };
  render() {
    return (
      <React.Fragment>
        <span onClick={this.openModal} role="presentation" className={styles.link}>
          {this.props.t('features.Dashbord.components.EmployeePopUp.here')}
        </span>
        <PaySetupDescriptionModal isOpen={this.state.isModalOpen} hideModal={this.closeModal} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(EmployeePopUp);
